import React, { useState } from 'react';

const AddEmployeeForm = ({ onSuccess, onCancel }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // For now, simulate adding employee by calling onSuccess with new employee data
    const newEmployee = {
      id: Date.now(),
      name,
      email,
      phone,
    };
    onSuccess(newEmployee);
  };

  return (
    <form onSubmit={handleSubmit} className="add-employee-form">
      <div>
        <label>Name:</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          autoFocus
        />
      </div>
      <div>
        <label>Email:</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>
      <div>
        <label>Phone:</label>
        <input
          type="tel"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          required
        />
      </div>
      <div className="form-buttons">
        <button type="submit">Add Employee</button>
        <button type="button" onClick={onCancel}>Cancel</button>
      </div>
    </form>
  );
};

export default AddEmployeeForm;
